<script lang="ts">
    import dayjs from 'dayjs'
    import Fa from 'svelte-fa'
    import { faPenNib } from '@fortawesome/free-solid-svg-icons'
    import { onMount } from 'svelte'
    import { EventSourcesRepository } from '../../../modules/eventsApi/event-sources/event-sources.repository'
    import { EventSourcesService } from '../../../modules/eventsApi/event-sources/event-sources.service'
    import { EventsRepository } from '../../../modules/eventsApi/events/events.repository'
    import { EventsService } from '../../../modules/eventsApi/events/events.service'
    import type { EventSource } from '../../../modules/eventsApi/event-sources/event-source.entity'
    import type { User } from '../../../modules/usersApi/users/user'
    import DateSelect from '../../_common/date-select.svelte'

    const esRep: EventSourcesRepository = new EventSourcesRepository()
    const esS: EventSourcesService = new EventSourcesService(esRep)

    const eventR: EventsRepository = new EventsRepository()
    const eventS: EventsService = new EventsService(eventR)

    let eventSources = []
    let query = ''
    let from: Date = null
    let to: Date = null
    let users: User[] = []
    export let source: string = ''

    let sources = []
    async function loadEventSources() {
        sources = await eventS.getEventSources()
    }

    function evaluateContent(es: EventSource) {
        if (es.source === 'whatsapp') {
            if (es.content.includes('[') && es.content.length < 30) {
                return es.content
            } else {
                return '[text]'
            }
        } else {
            return !!es.content ? es.content : '[sem conteúdo]'
        }
    }

    onMount(async () => {
        users = await window.api.users.companies.getCompanyUsers()
        await loadEventSources()
        loadEntities()
    })

    async function loadEntities() {
        eventSources = await esS.getAll({ from: dates.from, to: dates.to, sources: source })
    }

    let dates: { from: Date; to: Date } = window.api.utils.dates.today()
    function dateChanged(event) {
        dates = event.detail
        loadEntities()
    }
</script>

<div class="events">
    <div class="grid-act">
        <div class="input-group limit-source">
            <label for="" class="input-group-text">Origem</label>
            <select class="form-select" name="" id="" bind:value={source} on:change={loadEntities}>
                <option value="">Todos</option>
                {#each sources as item}
                    <option value={item}>{item}</option>
                {/each}
            </select>
        </div>
        <DateSelect startFrom={dates.from} startTo={dates.to} on:change={dateChanged} />
    </div>
    <div class="row mt-2">
        <div class="col text-muted text-center">
            A data selecionada refere-se à data referência do evento, e não à data em que o evento foi gerado.<br />
            Por exemplo, caso você queira ver os eventos relacionados a um agendamento feito no dia 01 do mês anterior, você deverá ir para esta data, mesmo que
            os eventos tenham ocorrido em datas diferentes.
        </div>
    </div>

    <div class="grid-head">
        <div class="row">
            <div class="col limit-date">Data de referência</div>
            <div class="col-1">Origem</div>
            <div class="col-2">Pessoa</div>
            <div class="col">Conteúdo</div>
            <div class="col-2">Evento</div>
            <div class="col limit-date">Data do evento</div>
            <div class="col-1">Usuário</div>
        </div>
    </div>
    <div class="grid-body">
        {#each eventSources as eventSource}
            <div class="row line liner py-1">
                {#each eventSource.event as event, i}
                    {@const user = users.find((el) => el.userId === event.userId)}
                    <div class="row row-line-0" class:removed={eventSource.status === 0}>
                        <div class="col limit-date">
                            {i === 0 ? dayjs(eventSource.externalDate).format('DD/MM/YYYY HH:mm:ss') : ''}
                        </div>
                        <div class="col-1">{i === 0 ? eventSource.source : ''}</div>
                        <div class="col-2 nowrap">{i === 0 ? eventSource.person.name : ''}</div>
                        <div class="col nowrap">{i === 0 ? evaluateContent(eventSource) : ''}</div>
                        <div class="col-2 nowrap">{event.event}</div>
                        <div class="col limit-date">{dayjs(event.createdAt).format('DD/MM/YYYY HH:mm:ss')}</div>
                        <div class="col-1 nowrap">{user ? user.userName : '-'}</div>
                    </div>
                {/each}
            </div>
        {/each}
    </div>
</div>

<style>
    .removed {
        opacity: 0.5;
    }
    .limit-date {
        max-width: 150px;
    }
    .grid-head,
    .grid-body {
        font-size: 13px;
    }
    .limit-source {
        max-width: 300px;
    }
</style>
